const allowedCustomers = {
  'PT. KIRANA PELITA JAYA': 769,
  'PT. BUMITAMA INDO PERKASA': 723,
  'PT. TUNAS CEMERLANG ABADI': 734,
  'PT. INDO JAYA EXPRESS': 700,
  'PT. KIRANA PALEM MANDIRI': 701
};

module.exports = allowedCustomers;
